export default __webpack_public_path__ + "static/media/excelente.b651b63d.png";